<template>
    <v-container
        flex
        fluid
        v-if="!customTemplate"
    >
        <v-sheet :elevation="elevation">
            <v-flex>
                <v-responsive :aspect-ratio="16/4">
                    <v-layout
                        column
                        justify-space-around
                        fill-height
                    >
                        <p class="text-xs-center" :class="messageClass">
                            {{message}}
                        </p>
                    </v-layout>
                </v-responsive>
            </v-flex>
        </v-sheet>
    </v-container>
    <component
        v-else
        :is="customTemplate"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Vue from 'vue';

const moduleName = 'PageNotFound';
const PAGE_NOT_FOUND = '404.html';

export default {
    name: moduleName,
    props: {
        customName: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: 'Page not found'
        },
        elevation: {
            type: Number,
            default: 3
        },
        messageClass: {
            type: String,
            default: 'display-3'
        }
    },
    methods: {
        ...mapActions('PageContent', ['switchTemplate']),
        ...mapActions('Layout', ['switchLayout'])
    },
    created() {
        if (this.customName) {
            this.switchLayout({
                layout: {
                    name: this.customName,
                    prefix: 'component-layout-',
                    path: '/layout/'
                }
            });
            this.switchTemplate({
                name: this.customName,
                prefix: 'component-tempalte-',
                path: '/template/'
            });
        } else {
            this.switchLayout({
                layout: {
                    name: PAGE_NOT_FOUND,
                    prefix: 'component-layout-',
                    path: '/layout/'
                }
            });
            this.switchTemplate({
                name: PAGE_NOT_FOUND,
                prefix: 'component-tempalte-',
                path: '/template/'
            });
        }
    },
    computed: {
        ...mapState('PageContent', ['currentTemplate']),
        customTemplate() {
            let decode = require('unescape');
            let me = this;
            if (this.currentTemplate === null) {
                return false;
            } else if (typeof this.currentTemplate == 'string') {
                if (Vue.options.components[this.currentTemplate]) {
                    let config = {
                        ...Vue.options.components[this.currentTemplate].options,
                        created() {
                            this.$slots = me.$slots;
                        }
                    };
                    delete config._Ctor;

                    return config;
                } else {
                    return {
                        template: decode(this.currentTemplate),
                        created() {
                            this.$slots = me.$slots;
                        }
                    };
                }
            } else {
                return Vue.extend({
                    ...me.currentTemplate,
                    created() {
                        this.$slots = me.$slots;
                    }
                });
            }
        }
    },
    metaInfo() {
        return {
            title: 'Page not found'
        };
    },
};
</script>